// extracted by mini-css-extract-plugin
module.exports = {"list":"privacy_list__1R36O","font":"privacy_font__24C8C","term":"privacy_term__34m0Y"};